<template>
    <div class="cv-list-widget">
        <div class="widget-header">
            <widgetSearch class="widget-search" icon="right" placeholder="Search CV" @keyup="searchCVs"></widgetSearch>
        </div>
        <div class="widget-body" :class="{ noScoll: cv_menu_open }">
            <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="is_loading"
                :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>

            <div class="widget-section" ref="cvs_list" v-if="!is_loading && cvsList.length > 0">
                <template v-for="(item, index) in cvsList">
                    <div class="cv-item" :key="index">
                        <div class="cv-content">
                            <div class="cv-content-header">
                                <div class="cv-name" @click="previewCv(item)">
                                    {{ item.name }}
                                </div>
                                <div class="cv-option">
                                    <widgetDropdown v-model="item.menu" :right="true" :hover="false"
                                        :interactive="true">
                                        <button class="btn-dropdown btn-menu">
                                            <img class="icon" style="height: 15px"
                                                src="@/assets/cv-editor-icons/menu-dot-gray.svg" />
                                        </button>
                                        <div slot="dropdown" class="dropdown-widget" style="right: -9px">
                                            <a class="dropdown-item" href="#" @click.prevent="editCv(item)">Edit
                                            </a>
                                            <app-dialog title="Delete Cv"
                                                ask="Are you sure you want to permanently delete cv?" yesText="Delete"
                                                noText="Cancel" @onComfirm="deleteCV(item)">
                                                <a class="dropdown-item" href="#">Delete </a>
                                            </app-dialog>
                                        </div>
                                    </widgetDropdown>
                                </div>
                            </div>

                            <div class="cv-content-body">
                                <div class="cv-image" @click="editCv(item)">
                                    <img :src="$fullUrl('images/profiles/' + item.path)">
                                </div>
                            </div>

                            <div class="cv-content-footer">
                                <div @click="previewCv(item)" v-if="item.user" class="cv-owner-names">
                                    {{ item.user.first_name + " " + item.user.last_name }}
                                </div>
                            </div>

                        </div>
                    </div>
                </template>
            </div>

            <div class="not-found" v-if="!is_loading && cvsList.length == 0">
                <widgetNotFoundWidget title="No Cvs Found" content="Looks like you haven’t added any CVs yet">
                    <img class="widget-img" src="@/assets/icons/member-notfound.svg" />
                </widgetNotFoundWidget>
            </div>
        </div>
    </div>
</template>
<script>
import { SITE_API, ACCOUNT_TYPE } from "@/Store/variable.js";
import { eventBus } from "@/main";
export default {
    name: "editor-menu",
    components: {},
    props: {
        isDraft: {
            type: Boolean,
            default: false,
        },
        templateAllowedVersion: {
            type: String,
            default: "1.3"
        }
    },
    data() {
        return {
            account_type: ACCOUNT_TYPE,
            cv_menu_open: false,
            cvsList: [],
            cvs_active_tab: 1,
            fullProfileData: {
                hasData: false,
                profile: {
                    profile_id: null,
                    profile_first_name: '',
                    profile_last_name: '',
                    profile_image: '',
                    profile_email: '',
                    profile_phone: '',
                    profile_address: '',
                    profile_description: '',
                },
                projects: [],
                employments: [],
                educations: [],
                trainings: [],
                certifications: [],
                skills: [],
                skillsObject: null
            },
            currentyProfileDataIndexing: {
                projects: 0,
                employments: 0,
                educations: 0,
                trainings: 0,
                certifications: 0,
                skills: 0
            },
            layers: [],
            templateData: null,
            isApplyingProfile: false,
            is_loading: true,
        };
    },
    computed: {},
    watch: {},
    mounted() {
        let vm = this;
        vm.getCvsData();
    },
    methods: {
        profileSelected(userId) {
            let vm = this;
            vm.fullProfileData.hasData = false;
            vm.currentyProfileDataIndexing = {
                projects: 0,
                employments: 0,
                educations: 0,
                trainings: 0,
                certifications: 0,
                skills: 0
            };
            vm.$store
                .dispatch("GET_ME_PROFILE", {
                    id: userId,
                    type: "student",
                })
                .then((response) => {
                    vm.joinPrepareProfileData(response.data, response.data.user);
                })
                .catch((error) => {
                    vm.fullProfileData.hasData = false;
                    vm.isLoading = false;
                    console.error({ error });
                });
        },
        joinPrepareProfileData(profileData, userProfile) {
            let vm = this;
            vm.fullProfileData.profile.profile_id = userProfile.copy;
            vm.fullProfileData.profile.profile_first_name = userProfile.first_name;
            vm.fullProfileData.profile.profile_last_name = userProfile.last_name;
            vm.fullProfileData.profile.profile_email = userProfile.email;
            vm.fullProfileData.profile.profile_image = userProfile.profile_picture;
            if (userProfile.profile) {
                vm.fullProfileData.profile.profile_phone = userProfile.profile.phone;
                vm.fullProfileData.profile.profile_address = userProfile.profile.address;
                vm.fullProfileData.profile.profile_description = vm.htmlToText(userProfile.profile.description);
            }
            vm.fullProfileData.projects = profileData.projects.map(item => {
                let { skillsObject, skillsArray } = vm.processSkills(item.skills);
                return {
                    project_name: item.name,
                    project_company: item.company ? item.company.name : '',
                    project_address: item.address,
                    project_description: vm.htmlToText(item.description),
                    project_start_date: item.from ? vm.moment(item.from).format('MMM DD YYYY') : '',
                    project_end_date: item.to ? vm.moment(item.to).format('MMM DD YYYY') : '',
                    project_skills: skillsArray,
                }
            });
            vm.fullProfileData.employments = profileData.employment.map(item => {
                let { skillsObject, skillsArray } = vm.processSkills(item.skills);
                return {
                    employment_company: item.company ? item.company.name : '',
                    employment_position: item.role,
                    employment_address: item.address,
                    employment_description: vm.htmlToText(item.description),
                    employment_start_date: item.from ? vm.moment(item.from).format('MMM DD YYYY') : '',
                    employment_end_date: item.to ? vm.moment(item.to).format('MMM DD YYYY') : '',
                    employment_skills: skillsArray,
                }
            });
            vm.fullProfileData.educations = profileData.educations.map(item => {
                return {
                    education_school: item.organization,
                    education_degree: item.degree,
                    education_address: item.address,
                    education_start_date: item.from ? vm.moment(item.from).format('MMM DD YYYY') : '',
                    education_end_date: item.to ? vm.moment(item.to).format('MMM DD YYYY') : '',
                }
            });
            vm.fullProfileData.trainings = profileData.trainings.map(item => {
                return {
                    training_certificate: item.title,
                    training_institution: item.organization,
                    training_address: item.address,
                    training_start_date: item.from ? vm.moment(item.from).format('MMM DD YYYY') : '',
                    training_end_date: item.to ? vm.moment(item.to).format('MMM DD YYYY') : '',
                }
            });
            vm.fullProfileData.certifications = profileData.certifications.map(item => {
                return {
                    certification_name: item.name,
                    certification_institution: item.organization,
                    certification_date: item.to ? vm.moment(item.to).format('MMM DD YYYY') : '',
                    certification_description: item.description
                }
            });
            let { skillsObject, skillsArray } = vm.processSkills(profileData.skills);
            vm.fullProfileData.skills = skillsArray;
            vm.fullProfileData.skillsObject = skillsObject;
            vm.isApplyingProfile = true;
            vm.fullProfileData.hasData = true;
            // Combine all data
            if (vm.fullProfileData.hasData) {
                vm.$emit("editDraftedCv", {
                    data: { layers: JSON.parse(vm.selected_cv.cvData).cvData, cv: vm.selected_cv, template: vm.templateData, profile: vm.fullProfileData }
                });
            }

        },
        processSkills(skills_data) {
            let skills = {
                tools: [],
                domains: [],
                languages: [],
                competences: [],
                roles: [],
            };
            let skillsArray = [];
            if (skills_data && skills_data.length > 0) {
                skills_data.forEach((skill) => {
                    skill.tools.forEach((item) => {
                        let obj = {
                            id: item.id,
                            name: item.name,
                            priority: item.priority,
                            editMode: false,
                            type: "tools",
                            order: item.order,
                            status: item.status,
                            searchable: item.status === 0 ? false : true,
                            level: parseInt(item.priority),
                        };
                        skills.tools.push(obj);
                        skillsArray.push(obj);
                    });
                    skill.domains.forEach((item) => {
                        let obj = {
                            id: item.id,
                            name: item.name,
                            priority: item.priority,
                            editMode: false,
                            type: "domains",
                            order: item.order,
                            status: item.status,
                            searchable: item.status === 0 ? false : true,
                            level: parseInt(item.priority),
                        };
                        skills.domains.push(obj);
                        skillsArray.push(obj);
                    });
                    skill.competences.forEach((item) => {
                        let obj = {
                            id: item.id,
                            name: item.name,
                            priority: item.priority,
                            editMode: false,
                            type: "competences",
                            order: item.order,
                            status: item.status,
                            searchable: item.status === 0 ? false : true,
                            level: parseInt(item.priority),
                        };
                        skills.competences.push(obj);
                        skillsArray.push(obj);
                    });
                    skill.roles.forEach((item) => {
                        let obj = {
                            id: item.id,
                            name: item.name,
                            priority: item.priority,
                            editMode: false,
                            type: "roles",
                            order: item.order,
                            status: item.status,
                            searchable: item.status === 0 ? false : true,
                            level: parseInt(item.priority),
                        };
                        skills.roles.push(obj);
                        skillsArray.push(obj);
                    });
                    skill.languages.forEach((item) => {
                        if (item.lang) {
                            let obj = {
                                id: item.id,
                                name: item.lang.name,
                                lang: item.lang.id,
                                editMode: false,
                                type: "languages",
                                order: item.order,
                                status: item.status,
                                searchable: item.status === 0 ? false : true,
                                level: parseInt(item.level),
                            };
                            skills.languages.push(obj);
                            skillsArray.push(obj);
                        }
                    });
                });
            }
            return {
                skillsObject: skills,
                skillsArray
            };
        },
        editCv(item) {
            let vm = this;
            vm.selected_cv = item;
            let cvData = JSON.parse(vm.selected_cv.cvData);
            if (cvData.version == vm.templateAllowedVersion) {
                vm.$store
                    .dispatch("CVS_GET_TEMPLATE_ITEM", {
                        template_id: item.template_id || null,
                    })
                    .then((response) => {
                        vm.templateData = JSON.parse(response.data.cvData);
                        vm.profileSelected(item.user_id);
                    })
                    .catch((error) => {
                        console.error({ error });
                    });
            } else {
                vm.$notify({
                    group: "status",
                    title: "Message",
                    text: "This CV is not supported.",
                    type: "warn",
                    duration: 3000,
                });
            }
        },
        searchCVs({ target }) {
            let vm = this;
            let query = target.value;
            vm.is_loading = true;
            vm.$store
                .dispatch("CVS_GET_CVS", {
                    text: query,
                    type: vm.account_type,
                })
                .then((response) => {
                    vm.is_loading = false;
                    vm.cvsList = response.data;
                })
                .catch((error) => {
                    vm.is_loading = false;
                    console.error({ error });
                });
        },
        deleteCV(item) {
            let vm = this;
            vm.$store
                .dispatch("CVS_DELETE_CV", { id: item.id, type: vm.account_type })
                .then((response) => {
                    vm.getCvsData();
                    vm.$notify({
                        group: "status",
                        title: "Messsage",
                        text: "CV deleted",
                        type: "success",
                        duration: 3000,
                    });
                })
                .catch((error) => {
                    vm.$notify({
                        group: "status",
                        title: "Message",
                        text: "Something went wrong",
                        type: "warn",
                        duration: 3000,
                    });
                    console.error({ error });
                });
        },
        getCvsData() {
            let vm = this;
            vm.is_loading = true;
            if (vm.account_type == "school") {
                vm.$store
                    .dispatch("CVS_GET_CVS", {
                        type: vm.account_type,
                        isDraft: true,
                        origin: "internal"
                    })
                    .then((response) => {
                        vm.is_loading = false;
                        vm.cvsList = response.data;
                    })
                    .catch((error) => {
                        vm.is_loading = false;
                        console.error({ error });
                    });
            } else {
                let user_id = vm.$getLoggedUser().id;
                vm.$store
                    .dispatch("CVS_GET_CVS", {
                        type: vm.account_type,
                        user_id: user_id,
                    })
                    .then((response) => {
                        vm.is_loading = false;
                        vm.cvsList = response.data;
                    })
                    .catch((error) => {
                        vm.is_loading = false;
                        console.error({ error });
                    });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.cv-list-widget {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;

    .widget-header {
        margin-bottom: 5px;
        height: 50px;
        display: flex;
        align-items: center;
        padding: 0px 5px;

        .widget-search {

            width: 100%;
        }
    }

    .widget-body {
        height: calc(100% - 55px);
        overflow-y: auto;
        position: relative;

        &.noScoll {
            overflow-y: hidden !important;
        }

        .widget-section {
            display: grid;
            grid-template-columns: calc(50% - 2.5px) calc(50% - 2.5px);
            grid-gap: 5px;
            width: 100%;
            padding: 5px;

            .cv-item {
                box-sizing: border-box;
                background: #f6f6f6;
                border-radius: 5px;
                padding: 6px;
                display: flex;
                position: relative;
                cursor: pointer;
                flex-direction: column;

                .cv-content-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 35px;

                    .cv-name {
                        font-size: 12px;
                        text-transform: none;
                        width: 100%;
                        overflow: hidden;
                        text-decoration: none;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        margin-right: 10px;
                    }

                    .cv-date {
                        color: #8c8c8c;
                        font-size: 11px;
                        white-space: nowrap;
                    }
                }

                .cv-content-body {
                    height: 150px;
                    display: flex;
                    width: 100%;

                    .cv-image {
                        height: 100%;
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-radius: 5px;
                        overflow: hidden;
                        border: 1px solid #d6e0ea;

                        img {
                            width: 100%;
                            object-fit: cover;
                            height: 100%;
                        }
                    }
                }

                .cv-content-footer {
                    margin-top: 10px;

                    .cv-owner-names {
                        color: #000000;
                        font-size: 10px;
                        margin-bottom: 1px;
                    }
                }

            }
        }

        .cv-widget-section {
            display: grid;
            grid-cv-columns: 48% 48%;
            grid-gap: 10px;
            width: 100%;

            .cv-item {
                box-sizing: border-box;
                border-radius: 10px;
                height: 200px;
                display: flex;
                justify-content: center;
                flex-direction: column;
                position: relative;
                cursor: pointer;

                &.applied {
                    border: 2px solid #1ba5a4;
                }

                .cv-header {
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    right: 0px;
                    display: flex;
                    justify-content: flex-end;
                    align-items: flex-start;
                    padding-top: 10px;
                    padding-right: 6px;
                    background: black;
                    background: linear-gradient(180deg,
                            rgba(0, 0, 0, 0.5) 9%,
                            rgba(255, 255, 255, 0) 97%);
                    z-index: 22;
                    height: 50px;
                    transition: all 0.5s ease;
                    border-top-left-radius: 10px;
                    border-top-right-radius: 10px;
                }

                &:hover {
                    .cv-header {
                        transition: all 0.5s ease;
                        top: 0px;
                    }
                }

                .cv-img {
                    height: calc(100% - 40px);
                    display: flex;
                    flex-direction: column;
                    position: relative;
                    border-radius: 10px;
                    overflow: hidden;
                    border: 1px solid #d6e0ea;

                    img {
                        width: 100%;
                        object-fit: cover;
                        height: 100%;
                    }

                    .default-cv {
                        position: absolute;
                        bottom: 0px;
                        background: #1ba5a4;
                        left: 0px;
                        right: 0px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 29px;
                        color: #fff;
                    }
                }

                .cv-name {
                    padding-top: 10px;
                    height: 30px;
                    font-size: 12px;
                    overflow: hidden;
                    display: block;
                    -webkit-line-clamp: 2;
                    display: box;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    text-overflow: ellipsis;
                    white-space: normal;
                }
            }
        }
    }

    .widget-modal-body-noscoll {
        .btn-upload {
            display: flex;
            align-items: center;
            margin: 10px 0px;
            color: #0884af;

            .upload-icon {
                margin-right: 10px;
            }
        }
    }

    .btn-send-message {
        position: fixed;
        z-index: 999;
        bottom: 97px;
        right: 21px;
        background: #1ba5a4;
        border: 1px solid #087a79;
        box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
        border-radius: 5px;
        height: 40px;
        padding: 0px 17px;
        color: #fff;
    }
}
</style>